import { render, staticRenderFns } from "./PercentagesNumeration.vue?vue&type=template&id=eb9e48b2&"
import script from "./PercentagesNumeration.vue?vue&type=script&lang=js&"
export * from "./PercentagesNumeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports